var ol = require('openlayers');
var $ = require('jquery');
var utils = require("Utils");

var pixelRatio = Math.round(utils.getDevicePixelRatio());

var OmsSource = function(options){
    var that = this,
        _options = {};

    that._urlTemplate = options.urlTemplate
        ? options.urlTemplate
        : "";

    if (that._urlTemplate != "") {
        if (options.tilesQuality){
            that._urlTemplate += '&q=' + options.tilesQuality;
        }
        if (pixelRatio !== 1) {
            that._urlTemplate += '&retina=' + pixelRatio;
        }
    }

    that._layers = options.layers
        ? options.layers
        : [];

    that._mapCode = options.mapCode
        ? options.mapCode
        : "";

    delete options['urlTemplate'];
    delete options['layers'];
    delete options['mapCode'];

    _options.tilePixelRatio = pixelRatio;
    _options.transition = 0;

    $.extend(true, _options, options);
    _options.url = that._urlTemplate
        .replace('{map_code}', that._mapCode)
        .replace('{layers}', that._layers.join(','));

    ol.source.XYZ.call(this, _options);

    that.loadingTiles = [];

    that.on('tileloadstart', function(e) {
        that.loadingTiles.push(e.tile);
    });

    that.on(['tileloadend', 'tileloaderror'], function(e) {
        var index = that.loadingTiles.indexOf(e.tile);
        if(~index){
            that.loadingTiles.splice(index, 1);
        }
    });

    that.lastUpdateTimestamp = false;
};

/**
 *
 * @type {{setLayers: Function}}
 */
OmsSource.prototype = {};

ol.inherits(OmsSource, ol.source.XYZ);

OmsSource.prototype.setActiveLayers = function(ids){
    var that = this,
        url;

    that._layers = ids;

    if (!that._layers.length) {
        that.setUrl('');
        return;
    }

    url = that._urlTemplate
        .replace('{map_code}', that._mapCode)
        .replace('{layers}', that._layers.join(','));

    if (that.lastUpdateTimestamp){
        url += '&_=' + that.lastUpdateTimestamp;
    }

    that.setUrl(url);
};

OmsSource.prototype.getActiveLayers = function() {
    return this._layers;
};

OmsSource.prototype.update = function() {
    var that = this,
        i, tile, notLoadedCount = 0;

    for( i in that.tileCache.entries_){
        tile = that.tileCache.entries_[i].value_;
        if (tile.getState() != ol.TileState.LOADED) {
            notLoadedCount += 1;
        }
    }
    that.tileCache.clear();

    that.dispatchEvent({
        "type": 'cacheCleared',
        'notLoaded': notLoadedCount
    });
    that.lastUpdateTimestamp = $.now();

    that.changed();

    that.setActiveLayers(that._layers);

    return that;
};

OmsSource.prototype.cancelLoading = function() {
    var that = this;

    that.loadingTiles.forEach(function(tile){
        tile.getImage().src = '';
        tile.changed();
    });

    that.loadingTiles.length = 0;

    return that;
};

module.exports = OmsSource;



//////////////////
// WEBPACK FOOTER
// ./src/View/OmsSource.js
// module id = 43
// module chunks = 0